'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _defaultAvatarRing = require('./default-avatar-ring.png');

var _defaultAvatarRing2 = _interopRequireDefault(_defaultAvatarRing);

var _defaultAvatar = require('./default-avatar.png');

var _defaultAvatar2 = _interopRequireDefault(_defaultAvatar);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getImgSrc = function getImgSrc(src) {
    if (src !== undefined && src !== '') {
        return src;
    }
    return _defaultAvatarRing2.default;
};
var Avatar = function Avatar(_ref) {
    var src = _ref.src,
        onEdit = _ref.onEdit,
        onDelete = _ref.onDelete,
        editable = _ref.editable,
        className = _ref.className,
        circle = _ref.circle,
        borderless = _ref.borderless,
        roundedCorners = _ref.roundedCorners;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        editFocused = _useState2[0],
        setEditFocused = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        deleteFocused = _useState4[0],
        setDeleteFocused = _useState4[1];

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('show-avatar-comp', 'cc-avatar-comp', className, {
                'cc-avatar-circle': circle,
                'cc-borderless': borderless,
                'cc-rounded': roundedCorners,
                'cc-avatar-updates-visible': editFocused || deleteFocused
            }) },
        _react2.default.createElement('img', { src: getImgSrc(src), alt: 'avatar' }),
        editable && _react2.default.createElement(
            'div',
            { className: 'cc-item-edit' },
            _react2.default.createElement(
                _Button2.default,
                {
                    className: 'cc-item-edit-button',
                    bsStyle: 'link',
                    bsSize: 'sm',
                    onFocus: function onFocus() {
                        return setEditFocused(true);
                    },
                    onBlur: function onBlur() {
                        return setEditFocused(false);
                    },
                    onClick: onEdit },
                'Edit'
            ),
            onDelete && _react2.default.createElement(
                _Button2.default,
                {
                    className: 'cc-item-delete-button',
                    bsStyle: 'link',
                    bsSize: 'sm',
                    onFocus: function onFocus() {
                        return setDeleteFocused(true);
                    },
                    onBlur: function onBlur() {
                        return setDeleteFocused(false);
                    },
                    onClick: onDelete },
                'Remove'
            )
        )
    );
};

Avatar.propTypes = {
    className: _propTypes2.default.string,
    src: _propTypes2.default.string,
    editable: _propTypes2.default.bool,
    onEdit: _propTypes2.default.func,
    onDelete: _propTypes2.default.func,
    circle: _propTypes2.default.bool,
    borderless: _propTypes2.default.bool,
    roundedCorners: _propTypes2.default.bool
};
Avatar.defaultProps = {
    circle: false,
    borderless: false,
    roundedCorners: true
};
Avatar.DEFAULT_AVATAR = _defaultAvatarRing2.default;
Avatar.BORDERLESS_AVATAR = _defaultAvatar2.default;
exports.default = Avatar;
//# sourceMappingURL=index.js.map